import React, { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { FormControl, FormHelperText, InputLabel, Select, MenuItem, useMediaQuery, Theme } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import { img } from '../../imgs'

type Props = {
  form: UseFormReturn<any>
  names: string
  items: any[]
  label?: string
  placeholder?: string
  variant?: 'standard' | 'filled' | 'outlined'
  color?: 'primary' | 'secondary'
  disabled?: boolean
  required?: boolean
  focused?: boolean
  menuItemNone?: string
  onClickItem?: (id: number) => void
  onSubmit?: (event: any) => void
}

const DropDown = (props: any, variant: string) => {
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  return <img src={img.dropdown} alt="" width={sm && variant === 'outlined' ? '10px' : 'auto'} {...props} />
}

export const SelectInput: React.FC<Props> = ({
  form,
  names,
  items = [],
  variant = 'outlined',
  color = 'primary',
  label = 'Тема',
  placeholder,
  disabled = false,
  focused,
  menuItemNone = undefined,
  onClickItem = () => {},
  onSubmit = () => {},
}): JSX.Element => {
  const { register, formState } = form
  const { onBlur, ref } = register(names)

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [themeValue, setThemeValue] = useState<string>('')
  const [showPlaceholder, setShowPlaceholder] = useState<boolean>(false)

  const handleChange = (event: SelectChangeEvent<typeof themeValue>) => {
    const {
      target: { value },
    } = event
    setThemeValue(value)
    onSubmit(event)
    onBlur(event).then(() => {})
  }

  const handleBlur = (event: any) => {
    onBlur(event).then(() => setShowPlaceholder(event.target.value === undefined))
  }

  const handleFocus = () => {
    setShowPlaceholder(true)
  }

  const handleClose = () => {
    setTimeout(() => (document.activeElement as HTMLElement).blur(), 0)
  }

  return (
    <FormControl fullWidth focused={focused} disabled={disabled} variant={variant} color={color}>
      <InputLabel>{label}</InputLabel>
      <Select
        {...register(names)}
        ref={ref}
        name={names}
        displayEmpty
        value={themeValue}
        onBlur={handleBlur}
        onFocus={handleFocus}
        onClose={handleClose}
        onChange={handleChange}
        IconComponent={(props) => DropDown(props, variant)}
        renderValue={(selected: any) => {
          if (selected.length === 0 && placeholder && showPlaceholder) {
            return (
              <span style={{ opacity: 0.5, fontSize: sm ? 11 : 14, marginLeft: sm ? 0 : 3, fontWeight: 600 }}>
                {placeholder}
              </span>
            )
          }
          return selected
        }}
      >
        {menuItemNone && (
          <MenuItem value="" onClick={handleBlur}>
            {menuItemNone}
          </MenuItem>
        )}
        {items.map((item: any) => {
          const { id, title = '', name = '', text = '', firstName = '', middleName = '', lastName = '' } = item

          const fullName = `${lastName} ${firstName}${item.middleName ? ` ${item.middleName}` : ''}`

          return (
            <MenuItem
              id={id}
              key={id}
              disableRipple
              onClick={() => onClickItem(id)}
              value={title || name || text || fullName}
            >
              <span style={{ fontSize: 14 }}>{title || name || text || fullName}</span>
            </MenuItem>
          )
        })}
      </Select>
      <FormHelperText>{formState.errors[names]?.message}</FormHelperText>
    </FormControl>
  )
}
